import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const HackIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M4 1.5C4 1.22386 4.22386 1 4.5 1H5C5.27614 1 5.5 1.22386 5.5 1.5V2H6C6.27614 2 6.5 2.22386 6.5 2.5V4H9.5V2.5C9.5 2.22386 9.72386 2 10 2H10.5V1.5C10.5 1.22386 10.7239 1 11 1H11.5C11.7761 1 12 1.22386 12 1.5V2C12 2.27614 11.7761 2.5 11.5 2.5H11V4H12C12.2761 4 12.5 4.22386 12.5 4.5V6.5C12.5 6.22386 12.7239 6 13 6H13.5C13.7761 6 14 6.22386 14 6.5V8H14.5C14.7761 8 15 8.22386 15 8.5V11.5C15 11.7761 14.7761 12 14.5 12H14C13.7239 12 13.5 11.7761 13.5 11.5V10H13C12.7239 10 12.5 9.77614 12.5 9.5V10.5C12.5 10.7761 12.2761 11 12 11H4C3.72386 11 3.5 10.7761 3.5 10.5V9.5C3.5 9.77614 3.27614 10 3 10H2.5V11.5C2.5 11.7761 2.27614 12 2 12H1.5C1.22386 12 1 11.7761 1 11.5V8.5C1 8.22386 1.22386 8 1.5 8H2V6.5C2 6.22386 2.22386 6 2.5 6H3C3.27614 6 3.5 6.22386 3.5 6.5V4.5C3.5 4.22386 3.72386 4 4 4H5V2.5H4.5C4.22386 2.5 4 2.27614 4 2V1.5ZM5 6.5C5 6.22386 5.22386 6 5.5 6H6C6.27614 6 6.5 6.22386 6.5 6.5V7C6.5 7.27614 6.27614 7.5 6 7.5H5.5C5.22386 7.5 5 7.27614 5 7V6.5ZM10 6C9.72386 6 9.5 6.22386 9.5 6.5V7C9.5 7.27614 9.72386 7.5 10 7.5H10.5C10.7761 7.5 11 7.27614 11 7V6.5C11 6.22386 10.7761 6 10.5 6H10Z"
		></path>
		<path
			fill="currentColor"
			d="M5.5 12C5.22386 12 5 12.2239 5 12.5V13.5H4.5C4.22386 13.5 4 13.7239 4 14V14.5C4 14.7761 4.22386 15 4.5 15H6C6.27614 15 6.5 14.7761 6.5 14.5V12.5C6.5 12.2239 6.27614 12 6 12H5.5Z"
		></path>
		<path
			fill="currentColor"
			d="M10 12C9.72386 12 9.5 12.2239 9.5 12.5V14.5C9.5 14.7761 9.72386 15 10 15H11.5C11.7761 15 12 14.7761 12 14.5V14C12 13.7239 11.7761 13.5 11.5 13.5H11V12.5C11 12.2239 10.7761 12 10.5 12H10Z"
		></path>
	</svg>
))
